<template>
  <button
    class="default-btn d-flex align-center justify-center gap-2"
    :style="buttonStyle"
    type="submit"
    :disabled="isLoading"
  >
    <v-progress-circular
      v-if="isLoading"
      class="mr-2"
      indeterminate
      size="18"
      width="2"
      :color="secondaryColor"
    >
    </v-progress-circular>
    <i v-if="icon" :class="icon"  class="mr-2" size="20">{{ icon }}</i>
    <span>{{ label }}</span>
  </button>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "PrimaryButton",
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "submit",
    },
    label: {
      type: String,
      default: "Entrar",
      required: true,
    },
    icon: {
      type: String,
      default: null
    }
  },
  setup() {
    const secondaryColor = computed(() => "#ffffff");

    const buttonStyle = computed(() => ({
      background: "linear-gradient(135deg, var(--brand-deep), var(--brand2))",
      boxShadow: "var(--brand-shadow)",
    }));

    return {
      buttonStyle,
      secondaryColor,
    };
  },
});
</script>

<style lang="scss" scoped>
.default-btn {
  width: 100%;
  border: none;
  cursor: pointer;
  color: #fff;
  font-family: var(--fontFamily);
  font-size: 14px;
  font-weight: 700;
  padding: 12px 24px;
  border-radius: 10px;
  transition: filter 0.2s ease;

  &:hover {
    filter: brightness(1.1);
  }
  &:disabled {
    opacity: 0.7;
    cursor: default;
  }
}
</style>
